module.exports = __webpack_public_path__ + "img/icey-active.f2c1050c.png";